import React, { useEffect, useState } from 'react';
import { ApprovalFlowService } from '../../../../../services/v1/applicant_tracking/ApprovalFlowService';
import {
  ApprovalFlow,
  RequisitionType,
} from '../../../../../entities/applicant_tracking/ApprovalFlow';
import { ApprovalFlowSummary } from '../../../ApprovalFlows/components/ApprovalFlowSummary';
import { LoadingSpinner } from '../../../../../components/LoadingSpinner';

interface PropTypes {
  requisitionType: RequisitionType;
  locationId?: number;
  departmentId?: number;
  applicationId?: number;
}

export function ApprovalFlowContainer(props: PropTypes) {
  const [approvalFlow, setApprovalFlow] = useState<ApprovalFlow>(null);
  const [isLoading, setIsLoading] = useState(true);

  const getMatchingApprovalFlow = () => {
    if (
      (!props.locationId && props.departmentId) ||
      (props.locationId && !props.departmentId)
    ) {
      return setIsLoading(false);
    }

    ApprovalFlowService.getMatchingApprovalFlow(
      props.requisitionType,
      props.locationId,
      props.departmentId,
      props.applicationId,
    )
      .then(setApprovalFlow)
      .finally(() => setIsLoading(false));
  };

  useEffect(getMatchingApprovalFlow, [props.locationId, props.departmentId]);

  if (isLoading) return <LoadingSpinner />;

  return (
    <>
      {approvalFlow && (
        <>
          <h3>Approval Flow</h3>
          <div className='fs-6 text-dark-200 mb-4'>
            Your requisition will be reviewed by the following approvers
          </div>
          <ApprovalFlowSummary steps={approvalFlow.steps} />
        </>
      )}
    </>
  );
}
